// External Dependencies:
import React, { Component, PropTypes as T } from 'react'
import { connect } from 'react-redux'
import GoogleMapReact from 'google-map-react'

// Internal Dependencies:
import SearchMapMarker from './SearchMapMarker'

// Redux:
import {
	getSearchData,
	getPlaceData,
	setMapBounds,
	setAllowMapOverride,
	googleMapsApiLoading,
	googleMapsApiLoaded,
	hoverMapMarker,
	selectMapMarker,
	clearMapDetails
} from 'actions/search'

function createMapOptions( maps ) {
	return {
		styles: [{ 'featureType':'administrative', 'elementType':'labels.text.fill', 'stylers':[{ 'color':'#6195a0' }] }, { 'featureType':'administrative.province', 'elementType':'geometry.stroke', 'stylers':[{ 'visibility':'off' }] }, { 'featureType':'landscape', 'elementType':'geometry', 'stylers':[{ 'lightness':'0' }, { 'saturation':'0' }, { 'color':'#f5f5f2' }, { 'gamma':'1' }] }, { 'featureType':'landscape.man_made', 'elementType':'all', 'stylers':[{ 'lightness':'-3' }, { 'gamma':'1.00' }] }, { 'featureType':'landscape.natural.terrain', 'elementType':'all', 'stylers':[{ 'visibility':'off' }] }, { 'featureType':'poi', 'elementType':'all', 'stylers':[{ 'visibility':'off' }] }, { 'featureType':'poi.park', 'elementType':'geometry.fill', 'stylers':[{ 'color':'#bae5ce' }, { 'visibility':'on' }] }, { 'featureType':'road', 'elementType':'all', 'stylers':[{ 'saturation':-100 }, { 'lightness':45 }, { 'visibility':'simplified' }] }, { 'featureType':'road.highway', 'elementType':'all', 'stylers':[{ 'visibility':'simplified' }] }, { 'featureType':'road.highway', 'elementType':'geometry.fill', 'stylers':[{ 'color':'#fac9a9' }, { 'visibility':'simplified' }] }, { 'featureType':'road.highway', 'elementType':'labels.text', 'stylers':[{ 'color':'#4e4e4e' }] }, { 'featureType':'road.arterial', 'elementType':'labels.text.fill', 'stylers':[{ 'color':'#787878' }] }, { 'featureType':'road.arterial', 'elementType':'labels.icon', 'stylers':[{ 'visibility':'off' }] }, { 'featureType':'transit', 'elementType':'all', 'stylers':[{ 'visibility':'simplified' }] }, { 'featureType':'transit.station.airport', 'elementType':'labels.icon', 'stylers':[{ 'hue':'#0a00ff' }, { 'saturation':'-77' }, { 'gamma':'0.57' }, { 'lightness':'0' }] }, { 'featureType':'transit.station.rail', 'elementType':'labels.text.fill', 'stylers':[{ 'color':'#43321e' }] }, { 'featureType':'transit.station.rail', 'elementType':'labels.icon', 'stylers':[{ 'hue':'#ff6c00' }, { 'lightness':'4' }, { 'gamma':'0.75' }, { 'saturation':'-68' }] }, { 'featureType':'water', 'elementType':'all', 'stylers':[{ 'color':'#eaf6f8' }, { 'visibility':'on' }] }, { 'featureType':'water', 'elementType':'geometry.fill', 'stylers':[{ 'color':'#c7eced' }] }, { 'featureType':'water', 'elementType':'labels.text.fill', 'stylers':[{ 'lightness':'-49' }, { 'saturation':'-53' }, { 'gamma':'0.79' }] }],
		scrollwheel: false,
		gestureHandling: 'greedy',
		disableDefaultUI: window.innerWidth > siteData.mobile_max_width ? false : true
	}
}

class SearchMap extends Component {
	mapObject = false
	isMobile = false

	constructor( props ) {
		super( props )

		this.handleApiLoaded = this.handleApiLoaded.bind( this )
		this.handleOnChange = this.handleOnChange.bind( this )
		this.handleMapClick = this.handleMapClick.bind( this )
	}

	componentWillMount() {
		this.props.handleApiLoading()

		if ( this.props.searchResults.map_markers.length == 1 ) {
			this.props.selectFirstMarker( this.props.searchResults.map_markers[0] )
		}

		if ( window.innerWidth <= siteData.mobile_max_width ) {
			this.isMobile = true
		}
	}

	componentDidUpdate() {
		const { allowMapOverride } = this.props

		if ( this.props.searchResults.map_markers.length == 1 ) {
			this.props.selectFirstMarker( this.props.searchResults.map_markers[0] )
		}

		if ( allowMapOverride && this.mapObject ) {
			if ( this.props.searchResults.map_zoom ) {
				this.mapObject.setZoom( this.props.searchResults.map_zoom )
			}

			if ( this.props.searchResults.map_center ) {
				this.mapObject.setCenter( this.props.searchResults.map_center )
			}
		}
	}

	componentWillUnmount() {
		google.maps.event.clearListeners( this.mapObject, 'dragstart' )
		google.maps.event.clearListeners( this.mapObject, 'dragend' )
		google.maps.event.clearListeners( this.mapObject, 'zoom_changed' )
	}

	handleApiLoaded( map ) {
		this.props.handleApiLoaded()

		this.mapObject = map.map

		// update the search data when finished dragging:
		this.mapObject.addListener( 'dragend', ( e ) => {
			document.body.classList.remove( 'map-drag' )

			this.handleOnChange( this.mapObject.getBounds(), this.mapObject.getCenter(), this.mapObject.getZoom() )
		} )
	}

	handleOnChange( LatLngBounds, LatLngCenter, zoom ) {
		let args = {
			blockUI: false
		}

		let bounds = LatLngBounds.toJSON()
		let center = LatLngCenter.toJSON()

		this.props.handleOnChange( bounds, center, zoom, this.props.searchTerm, args )

		if ( this.isMobile ) {
			this.props.clearMapDetails()
		}
	}

	handleMouseOver( markerData, e ) {
		this.props.handleMarkerHover( {
			display: true,
			uuid: markerData.uuid,
			title: markerData.title,
			type: markerData.type,
			street_address: markerData.street_address
		} )
	}

	handleMarkerClick( markerData, e ) {
		e.preventDefault()
		e.stopPropagation()

		this.props.handleMarkerClick( markerData )
	}

	handleMapClick( e ) {
		let node = e.event.target

		if ( this.isMobile && 'circle' != node.nodeName && 'path' != node.nodeName ) {
			this.props.clearMapDetails()
		}
	}

	distanceToMouse = ( markerPos, mousePos, markerProps ) => {
		const x = markerPos.x
		const y = markerPos.y

		return Math.sqrt(
			( x - mousePos.x ) * ( x - mousePos.x ) + ( y - mousePos.y ) * ( y - mousePos.y )
		)
	}

	render() {
		const { defaultCenter, mapCenter, searchResults, hoveredMarker, selectedMarker } = this.props
		const zoom = searchResults.map_zoom ? searchResults.map_zoom : this.props.zoom
		var markersMarkup = ''

		if ( searchResults.map_markers ) {
			markersMarkup = searchResults.map_markers.map( ( e, i ) => {
				return (
					<SearchMapMarker
						key={ i }
						lat={ e.lat }
						lng={ e.lng }
						title={ e.title }
						place_type={ e.place_type }
						address={ e.street_address }
						selectedMarker={ selectedMarker }
						onClick={ this.handleMarkerClick.bind( this, e ) }
						onMouseOver={ this.handleMouseOver.bind( this, e ) }
					/>
				)
			})
		}

		return (
			<div className="-map">
				{ hoveredMarker &&
					<div className={ hoveredMarker.display ? '-info content-box -with-link is-visible' : '-info content-box -with-link' } onClick={ this.handleMarkerClick.bind( this, hoveredMarker ) }>
						<div className="-text">
							<h5 className="-title" dangerouslySetInnerHTML={ { __html: hoveredMarker.title } }></h5>
							<h6 className="-type">{ hoveredMarker.type }</h6>

							{ hoveredMarker.street_address &&
								<p className="-address" dangerouslySetInnerHTML={ { __html: hoveredMarker.street_address } }></p>
							}

							<p className="-more-info">Click for more info</p>
						</div>
					</div>
				}

				<GoogleMapReact
					bootstrapURLKeys={ {
						key: siteData.google_maps_api_key
					} }
					defaultCenter={ defaultCenter }
					center={ mapCenter }
					defaultZoom={ 11 }
					zoom={ zoom }
					options={ createMapOptions }
					onGoogleApiLoaded={ this.handleApiLoaded }
					onClick={ this.handleMapClick }
					yesIWantToUseGoogleMapApiInternals
				>
					{ markersMarkup }
				</GoogleMapReact>
			</div>
		)
	}
}

SearchMap.defaultProps = {
	defaultCenter: {
		lat: -33.868820,
		lng: 151.209296
	},
	zoom: 11
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		mapCenter: state.search.mapCenter,
		searchTerm: state.search.searchTerm,
		searchResults: state.search.searchResults,
		hoveredMarker: state.search.hoveredMarker,
		selectedMarker: state.search.selectedMarker,
		allowMapOverride: state.search.allowMapOverride
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {
		handleApiLoading() {
			dispatch( googleMapsApiLoading() )
		},

		handleApiLoaded() {
			dispatch( googleMapsApiLoaded() )
		},

		handleMarkerHover( markerData ) {
			dispatch( hoverMapMarker( markerData ) )
			dispatch( getPlaceData( markerData.uuid ) )
		},

		handleMarkerClick( markerData ) {
			dispatch( selectMapMarker( markerData ) )
			dispatch( getPlaceData( markerData.uuid ) )
		},

		selectFirstMarker( markerData ) {
			dispatch( selectMapMarker( markerData ) )
		},

		setAllowMapOverride( state ) {
			dispatch( setAllowMapOverride( state ) )
		},

		handleOnChange( bounds, center, zoom, searchTerm, args ) {
			dispatch( setMapBounds( bounds, center, zoom ) )
			dispatch( getSearchData( searchTerm, args ) )
		},

		clearMapDetails() {
			dispatch( clearMapDetails() )
		}
	}
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)( SearchMap )



// WEBPACK FOOTER //
// ./components/Search/SearchMap.jsx